import axios from "axios";
import { getPythonApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

export const getInitialQuestion = async (topic?: string) => {
  const response = await axios.get(
    `${getPythonApiUrlWithVersion()}/studio/initial_question`,
    {
      params: topic ? { topic } : undefined,
      headers: getAuthHeaders(),
    },
  );

  return response.data;
}

export const startConversation = async (user_id: any, assistant_question: string, user_response: string) => {
  const response = await axios.post(
    `${getPythonApiUrlWithVersion()}/studio/start_conversation`,
    { user_id, assistant_question, user_response },
    { headers: getAuthHeaders() },
  );

  return response.data;
}

export const sendMessage = async (user_id: any, conversationId: string, message: string) => {
  const response = await axios.post(
    `${getPythonApiUrlWithVersion()}/studio/conversation/${conversationId}/message`,
    { user_id, message },
    { headers: getAuthHeaders() }
  );

  return response.data;
};

export const generateInsights = async (user_id: string, conversation_id: string) => {
  const response = await axios.post(
    `${getPythonApiUrlWithVersion()}/conversation/${conversation_id}/insights`,
    { user_id },
    { headers: getAuthHeaders() }
  );
  return response.data.insights;
}

export const getInterviewerTTSResponse = async (message: string) => {
  const response = await fetch(
    `${getPythonApiUrlWithVersion()}/poc_tts`,
    {
      method: "POST",
      body: JSON.stringify({ message }),
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
    }
  );

  return response.body;
}

const getAuthHeaders = () => ({ Authorization: getAuthUser()?.accessToken });
